// `extension-alert-candidates-exchange-api.ts` — the Microsoft Exchange connect, which unlike Gmail
// and Outlook is not an OAuth round-trip: the user types their Exchange credentials and the tenant
// validates them against the server and stores them in one call.
import { request } from './request.ts'

/** `IUserPasswordDto`. */
export interface ExchangeCredentials {
  username: string
  password: string
}

/** `IValidateResponse`. A wrong password is a 200 with `success: false`, not an HTTP error. */
export interface ExchangeValidateResponse {
  success: boolean
}

/**
 * `validateAndSave` — POST, JSON body. ⚠️ A WRITE: on success the tenant stores the credentials as
 * the user's mail integration, and every message they send afterwards goes out through it.
 */
export async function validateAndSaveExchange(credentials: ExchangeCredentials): Promise<ExchangeValidateResponse> {
  return request('POST', '/chrome-extension-api/exchange/validateAndSave', credentials)
}
